import React from 'react'
import PaymentMessagePage from './payment-message'

const PaymentMessage = () => {
  return (
    <PaymentMessagePage/>
  )
}

export default PaymentMessage